import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import AsyncTaskDeleteModal from './AsyncTaskDeleteModal'; // @ts-expect-error no-type

import AsyncCampaignEditPanel from 'collaboration-sidebar/components/AsyncCampaignEditPanel';
import AsyncConfirmDeleteCommentModal from 'collaboration-sidebar/components/AsyncConfirmDeleteCommentModal';
import { IS_EMBEDDED_COMMENTS_ONBOARDING_ENABLED } from '../constants/CollaborationSidebarStateProperties';
import DeepCommentingOnboardingClickables from '../features/deepCommenting/components/DeepCommentingOnboardingClickables';
import { useCollaborationSidebarState } from '../hooks';
export default function Modals({
  confirmDeleteCommentModalProps,
  taskDeleteModalProps,
  campaignCreatePanelProps,
  showDeleteCommentModal,
  showTaskDeleteModal,
  showCampaignCreatePanel,
  withoutSidebar,
  isReady,
  IFrameError
}) {
  const {
    collaborationSidebarState
  } = useCollaborationSidebarState();
  const isOnboardingActive = collaborationSidebarState[IS_EMBEDDED_COMMENTS_ONBOARDING_ENABLED];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showDeleteCommentModal && /*#__PURE__*/_jsx(AsyncConfirmDeleteCommentModal, Object.assign({}, confirmDeleteCommentModalProps, {
      withoutSidebar: withoutSidebar,
      isReady: isReady,
      error: IFrameError
    })), showTaskDeleteModal && /*#__PURE__*/_jsx(AsyncTaskDeleteModal, Object.assign({}, taskDeleteModalProps)), showCampaignCreatePanel && /*#__PURE__*/_jsx(AsyncCampaignEditPanel, Object.assign({}, campaignCreatePanelProps)), isOnboardingActive && /*#__PURE__*/_jsx(DeepCommentingOnboardingClickables, {})]
  });
}